import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { AutoWidthCalculator } from 'ag-grid';
import {GridOptions} from "ag-grid/main";
import { GridApi } from 'ag-grid/main';
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility, Announcement, AnnouncementSummary, WpPerson,VIEW_BTN, AgGridUtility, DateUtility, ServerConstantsService } from '../shared';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService } from '../shared';
import {ProviderService} from "../provider-management/provider-management.service";

@Component({
  selector: 'app-admin-provider-summary',
  templateUrl: './admin-provider-summary.component.html',
  styleUrls: ['./admin-provider-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AdminProviderSummaryComponent implements OnInit {
  @ViewChild('header') header: ElementRef;
    public gridOptions;
    private gridApi;
    firstTime: Boolean = true;
    private gridColumnApi;
    public columnDefs:any;
    rowData:any;
    tabIndex:any="-1";
    shareData:any;
    tabToNextCell:any;
    index:any;
    serverConstants: any;
    innerNav:any;
  constructor(private dataService:DataService, private router:Router,
    private dateUtil: DateUtility,
    private agGridUtility: AgGridUtility,
    private authService:AuthService, private providerService:ProviderService,
    private http: HttpClient, private serverConstantsService: ServerConstantsService) {
    this.serverConstants = serverConstantsService.getConstants();
    this.columnDefs = [
      {headerName: 'Name', field: 'Name'},
      {headerName: 'Contact Name', field: 'ContactName' },
      {headerName: 'Phone', field: 'Phone', valueFormatter: this.agGridUtility.formatPhoneNumber,},
      {headerName: 'Email', field: 'Email'},
      {headerName: 'Contract Begin Date', field: 'ContractBeginDate'},
      {headerName: 'Contract End Date', field: 'ContractEndDate'},
      {headerName: 'Action', field: 'Action', cellRenderer: this.getEditButton,
      suppressFilter: true,
      suppressSorting: true}
    ];
    this.gridOptions = <GridOptions>{
      context: {
          componentParent: this
      }
    };
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if(nextCell.column.colDef.headerName === "Action"){
        return;
      }
      else{
        return nextCell;
      }
    }
  }

  ngOnInit() {
    this.index = JSON.parse(sessionStorage.getItem('ADPSH')).innerNavPages.find(x=> x.pageId === 'ADPSU');
    if(this.index.readOnly){
      this.tabIndex = "0";
    }
    this.innerNav = JSON.parse(sessionStorage.getItem('ADPSH'));

    this.http.get<any>(this.serverConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role : ' + data.roles[0].id);
            if(data.roles[0].id === 5){
                this.router.navigate(['dashboard']);
              } 
          }
        }  
        
        this.dataService.removeValueFromSharedDataMap('provider');
        let token = this.dataService.getSharedDataObject().get("token");
        this.providerService.getAllProvidersList(token).subscribe((data)=>{
          this.shareData = data;
          this.rowData =[];
          for(let i=0;i<data.length;i++){
            this.rowData.push({Name:data[i].providerName,
            ContactName:data[i].primaryContactLastName,
            Phone:data[i].primaryPhoneNumber,
            Email:data[i].primaryEmail,
            ContractBeginDate:this.dateUtil.convertFormattedDateFromServer(data[i].providerBeginDt),
            ContractEndDate:this.dateUtil.convertFormattedDateFromServer(data[i].providerEndDt),
            id:i
            })
          }
        });

      }, response => {
        console.log('error', response);
        if(response.status === 401){
          this.router.navigate(['dashboard']);
        }
      }, () => {

      });

  }
  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
  loadProviderDetails(){
    this.router.navigate(['admin/provider-management/provider-details']);
  }
  getEditButton(params) {
    const that = params.context.componentParent;
    const element = document.createElement('a');
    element.innerHTML = "<i class='fa fa-pencil'></i>";
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('provider',that.shareData[params.data.id]);
      that.router.navigate(['admin/provider-management/provider-details']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap('provider',that.shareData[params.data.id]);
        that.router.navigate(['admin/provider-management/provider-details']);
      }
      /*else if((!event.shiftKey && event.keyCode==9) && (params.rowIndex == (that.rowData.length -1))){
        event.preventDefault();
      setTimeout(() => that.header.nativeElement.focus(), 0);
      that.header.nativeElement.click();
      }*/

    });
    element.setAttribute("tabindex", "0");
    return element;
  }
  onGridReady(params) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.rowData);
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridAutoHeight(true);
    this.gridOptions.api.sizeColumnsToFit();
  }
  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.rowData.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }
  focusSummary(event) {
    if(this.rowData.length === 0){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
    else{
      this.firstTime = false;
      this.addEventListenerToSearch(event);
    }
  }

  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-provider-summary/admin-provider-summary.component.ts